import type { AppRouteModule } from '@/router/types';
import { t } from '@/hooks/web/useI18n';

const updateLogRoute: Array<AppRouteModule> = [
  {
    path: '/systemLogShow',
    name: 'systemLogShow',
    component: () =>
      import(/* webpackChunkName: "systemLogShow" */ '@/views/updateLog/SystemLogShow.vue'),
    meta: {
      title: t('系统更新日志'),
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
];

export default updateLogRoute;
